<template>
	<div class="main">
		<el-image class="introImg" :src="baseImgUrl + introImg"></el-image>
		<div class="cont">{{into}}</div>
	</div>
</template>

<script>
export default {
	name: "Intro",
	data() {
		return {
			baseImgUrl: process.env.VUE_APP_IMGURL,
			introImg: '',
			into: ''
		}
	},
	mounted() {
		this.$api.get('about/getIntro').then(res => {
			this.introImg = res.img;
			this.into = res.introEn;
		});
	}
}
</script>

<style scoped>
.main{ font-family: 'SiYuan-ExtraLight', sans-serif; }
@media (max-width: 520px){
	.main{ width: 100%; padding: 18px 0 12px 0; }
	.introImg{ width: 100%; height: 460px; animation: fadeInLeft; animation-duration: 2s; }
	.cont{ width: 100%; height: fit-content; font-size: 13px; line-height: 34px; animation: fadeInRight; animation-duration: 1.8s; white-space: pre-wrap; }
}
@media (min-width: 521px) and (max-width: 726px){
	.main{ width: 100%; display: flex; justify-content: space-between; padding: 18px 0 12px 0; }
	.introImg{ display: none; }
	.cont{ width: 100%; height: fit-content; font-size: 14px; line-height: 35px; animation: fadeInRight; animation-duration: 1.8s; white-space: pre-wrap; }
}
@media (min-width: 726px) and (max-width: 999px){
	.main{ width: 100%; display: flex; justify-content: space-between; padding: 18px 0 12px 0; }
	.introImg{ display: none; }
	.cont{ width: 100%; height: fit-content; font-size: 15px; line-height: 35px; animation: fadeInRight; animation-duration: 1.8s; white-space: pre-wrap; }
}
@media (min-width: 999px) and (max-width: 1251px){
	.main{ width: 100%; display: flex; justify-content: space-between; padding: 18px 0 12px 0; }
	.introImg{ width: 420px; height: 440px; margin-top: 12px; animation: fadeInLeft; animation-duration: 2s; }
	.cont{ width: 100%; height: fit-content; font-size: 15px; line-height: 35px; padding-left: 26px; animation: fadeInRight; animation-duration: 1.8s; white-space: pre-wrap; }
}
@media (min-width: 1252px) and (max-width: 1845px){
	.main{ width: 100%; display: flex; justify-content: space-between; padding: 18px 0 12px 0; }
	.introImg{ width: 520px; height: 500px; margin-top: 12px; animation: fadeInLeft; animation-duration: 2s; }
	.cont{ width: 100%; height: fit-content; font-size: 15px; line-height: 35px; padding-left: 26px; animation: fadeInRight; animation-duration: 1.8s; white-space: pre-wrap; }
}
@media (min-width: 1846px) and (max-width: 2200px){
	.main{ width: 100%; display: flex; justify-content: space-between; padding: 18px 0 12px 0; }
	.introImg{ width: 520px; height: 540px; margin-top: 12px; animation: fadeInLeft; animation-duration: 2s; }
	.cont{ width: 100%; height: fit-content; font-size: 16px; line-height: 36px; padding-left: 26px; animation: fadeInRight; animation-duration: 1.8s; white-space: pre-wrap; }
}
@media (min-width: 2201px){
	.main{ width: 100%; display: flex; justify-content: space-between; padding: 18px 0 12px 0; }
	.introImg{ width: 520px; height: 540px; margin-top: 12px; animation: fadeInLeft; animation-duration: 2s; }
	.cont{ width: 100%; height: fit-content; font-size: 18px; line-height: 40px; padding-left: 46px; animation: fadeInRight; animation-duration: 1.8s; white-space: pre-wrap; }
}
</style>